
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M12.105 1.785A7.213 7.213 0 003.05 11.92l-1.727 3.627a.75.75 0 001 1L5.95 14.82a7.196 7.196 0 002.324.79.75.75 0 10.234-1.482 5.699 5.699 0 01-2.126-.792.75.75 0 00-.72-.041l-2.076.989.989-2.077a.75.75 0 00-.041-.72 5.712 5.712 0 1110.222-4.953.75.75 0 101.412-.506 7.213 7.213 0 00-4.063-4.243zm2.064 7.91a3.045 3.045 0 012.294 5.064.75.75 0 00-.177.625l.191 1.104-1.067-.659a.75.75 0 00-.562-.092 3.059 3.059 0 11-.684-6.041h.005zm2.468-.78a4.545 4.545 0 00-2.473-.72 4.56 4.56 0 10.707 9.064l2.237 1.38a.75.75 0 001.132-.767l-.418-2.408a4.545 4.545 0 00-1.184-6.549z"}})])
          )
        }
      }
    